// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cabecera__head__Nzent {\r\n  text-align: center;\r\n}\r\n\r\n.Cabecera__logo__GGgRG {\r\n  width: 100%;\r\n  max-width: 340px;\r\n  height: auto;\r\n  display: block;\r\n  margin: 0 auto 18px;\r\n}\r\n\r\n.Cabecera__head__Nzent h1 {\r\n  font-size: 20px;\r\n  margin: 0;\r\n  font-weight: 700;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n.Cabecera__ot__jJt7O {\r\n  font-size: 13px;\r\n  color: var(--texto-tenue);\r\n  margin-top: 4px;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": "Cabecera__head__Nzent",
	"logo": "Cabecera__logo__GGgRG",
	"ot": "Cabecera__ot__jJt7O"
};
export default ___CSS_LOADER_EXPORT___;
